import { QueryKeys } from "@cede/utils";
import { useDependencies } from "./useDependencies";
import { useQuery } from "@tanstack/react-query";

const DEFAULT_CEDE_STORE_VERSION = "1.72.3";

export const useCedeStoreVersion = () => {
  const { backgroundHandler } = useDependencies();
  const { data: cedeStoreVersion } = useQuery<string>({
    queryKey: [QueryKeys.CEDE_STORE_VERSION],
    queryFn: () => backgroundHandler.getAppVersion().catch(() => DEFAULT_CEDE_STORE_VERSION),
  });

  const isGreaterVersion = (version: string) => {
    const [currentMajor, currentMinor, currentPatch] = (cedeStoreVersion || DEFAULT_CEDE_STORE_VERSION)
      .split(".")
      .map((v) => (v ? Number(v) : 0)) as [number, number, number];
    const [major, minor, patch] = version.split(".").map((v) => (v ? Number(v) : 0)) as [number, number, number];

    if (currentMajor > major) return true;
    if (currentMajor < major) return false;

    if (currentMinor > minor) return true;
    if (currentMinor < minor) return false;

    return currentPatch > patch;
  };

  return { cedeStoreVersion, isGreaterVersion };
};
